export function OrDivider({label = 'or continue with'}: {label?: string}) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            margin: '26px 0 22px'
        }}>
            <div style={{
                height: 1,
                backgroundColor: 'var(--tt-border)',
                flex: 1
            }} />
            <span style={{
                fontSize: 13.5,
                color: 'var(--tt-text-secondary)'
            }}>
                {label}
            </span>
            <div style={{
                height: 1,
                backgroundColor: 'var(--tt-border)',
                flex: 1
            }} />
        </div>
    );
}
